import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/result/:id',
    name: 'myLinkResult',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '歷史評估記錄',
    },
    component: () => import('@/components/myLink/result.vue'),
  },
  {
    path: '/report/A03/:rate',
    name: 'myLinkReportXJGS',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '心肌梗塞',
    },
    component: () => import('@/components/myLink/report/xjgs.vue'),
  },
  {
    path: '/report/A07/:rate',
    name: 'myLinkReportCancer',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '癌症(惡性腫瘤)',
    },
    component: () => import('@/components/myLink/report/cancer.vue'),
  },
  {
    path: '/report/A17/:rate',
    name: 'myLinkReportNZZ',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '腦卒中',
    },
    component: () => import('@/components/myLink/report/nzz.vue'),
  },
  {
    path: '/report/A05/:rate',
    name: 'myLinkReportTF',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '痛風',
    },
    component: () => import('@/components/myLink/report/tf.vue'),
  },
  {
    path: '/pay',
    name: 'myLinkPay',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '支付',
    },
    component: () => import('@/components/myLink/pay.vue'),
  },
  {
    path: '/buyOther/:orderId',
    name: 'CmhkH5BuyOtherDis',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '其他疾病風險',
    },
    component: () => import('@/components/myLink/buyOtherDis.vue'),
  },
  {
    path: '/question/four',
    name: 'myLinkQuestionFour',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '健康問卷',
    },
    component: () => import('@/components/myLink/question/four.vue'),
  },
  {
    path: '/history',
    name: 'myLinkHistory',
    meta: {
      needLogin: true, //設置此路由是否需要登錄狀態
      title: '歷史評估記錄',
    },
    component: () => import('@/components/myLink/history.vue'),
  },
  {
    path: '/login',
    name: 'myLinkLogin',
    meta: {
      needLogin: false, //設置此路由是否需要登錄狀態
      title: '登錄',
    },
    component: () => import('@/components/myLink/login.vue'),
  },
  {
    path: '/',
    name: 'cmhkProduct',
    meta: {
      needLogin: false, //設置此路由是否需要登錄狀態
      title: 'Medin AI',
    },
    component: () => import('@/components/newPage/product.vue'),
  },
  {
    path: '/caseS',
    name: 'cmhkCaseS',
    meta: {
      needLogin: false, //設置此路由是否需要登錄狀態
      title: 'S先生案例',
    },
    component: () => import('@/components/newPage/caseS.vue'),
  },
  {
    path: '/caseH',
    name: 'cmhkCaseH',
    meta: {
      needLogin: false, //設置此路由是否需要登錄狀態
      title: 'H先生案例',
    },
    component: () => import('@/components/newPage/caseH.vue'),
  },
  {
    path: '/extraDis',
    name: 'CmhkH5ExtraDis',
    meta: {
      needLogin: false, //設置此路由是否需要登錄狀態
      title: '評估結果',
    },
    component: () => import('@/components/myLink/extraDis.vue'),
  },

  //404
  {
    path: '/404',
    name: '404',
    meta: {
      title: '404',
    },
    component: () => import('@/components/404'),
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  routes: routes,
})

export default router
